<template>
  <div class="container">
    <v-data-table
      :headers="headers"
      :items="items"
      sort-by="calories"
      class="elevation-1"
      disable-pagination
      disable-filtering
      hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Προϊόντα</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                ΔΗΜΙΟΥΡΓΙΑ
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" md="8" sm="6">
                        <v-text-field
                            v-model="editedItem.code"
                            label="Κωδικός"
                            v-bind:error-messages="allerrors.code">
                        </v-text-field>

                        <v-text-field
                            v-model="editedItem.description"
                            label="Περιγραφή"
                            v-bind:error-messages="allerrors.description">
                        </v-text-field>

                        <v-select
                            label="Μονάδα Μέτρησης"
                            v-model="editedItem.measurementUnit"
                            v-bind:items="measurement_units"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.measurement_unit_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία ΦΠΑ"
                            v-model="editedItem.vatCategory"
                            v-bind:items="vat_categories"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.vat_category_id">
                        </v-select>

                        <v-select
                            label="Κατηγορία εσόδου"
                            v-model="editedItem.incomeCategory"
                            v-bind:items="income_categories"
                            item-text="description"
                            item-value="id"
                            clearable
                            return-object
                            v-bind:error-messages="allerrors.income_category_id">
                        </v-select>

                        <vuetify-money
                            v-model="editedItem.suggested_price"
                            label="Προτεινόμενη τιμή"
                            v-bind:options="moneyFieldOptions">
                        </vuetify-money>

                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="close">ΑΚΥΡΟ</v-btn>
                <v-btn color="blue darken-1" text @click="save" v-bind:loading="saveButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Διαγραφή εγγραφής "{{ editedItem.code }}";</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning darken-1" text @click="closeDelete">ΑΚΥΡΟ</v-btn>
                <v-btn color="error darken-1" text @click="deleteItemConfirm" v-bind:loading="deleteButtonDisabled">ΕΝΤΑΞΕΙ</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    data: () => ({
      moneyFieldOptions: {
          locale: "el-GR",
          prefix: "€",
          suffix: "",
          length: 12,
          precision: 4
      },
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: 'Κωδικός',
          align: 'start',
          //sortable: false,
          value: 'code',
        },
        { 
          text: 'Περιγραφή', 
          value: 'description' 
        },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      allerrors: [],
      items: [],
      products: [],
      measurement_units: [],
      vat_categories: [],
      income_categories: [],

      editedIndex: -1,
      editedItem: {
        code: '',
        description: '',
        measurementUnit: {},
        vatCategory: {},
        incomeCategory: {},
        suggested_price: 0,
      },
      defaultItem: {
        code: '',
        description: '',
        measurementUnit: {},
        vatCategory: {},
        incomeCategory: {},
        suggested_price: 0,
      },
      saveButtonDisabled: false,
      deleteButtonDisabled: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Προσθήκη' : 'Επεξεργασία'
      },

      editedItemName () {
        return 'yay'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      mixmatch(product) {
        product.vatCategory = this.vat_categories.find(x => x.id == product.vat_category_id)
        product.measurementUnit = this.measurement_units.find(x => x.id == product.measurement_unit_id)
        
        if (product.income_category_id != null)
          product.incomeCategory = this.income_categories.find(x => x.id == product.income_category_id)
        
        return product;
      },

      initialize () {
        axios.all([
          axios.get('/api/measurement-units/'),
          axios.get('/api/tax-authority/vat-categories'),
          axios.get('/api/tax-authority/income-categories'),
          axios.get('/api/products')
        ])
        .then(axios.spread((measurementUnitsResponse, vatCategoriesResponse, incomeCategoriesResponse, productsResponse) => {
          this.measurement_units = measurementUnitsResponse.data
          this.vat_categories = vatCategoriesResponse.data
          this.income_categories = incomeCategoriesResponse.data
          this.products = productsResponse.data
          this.items = this.products.map(product => this.mixmatch(product))

        }))
        .catch(error => { console.log(error) })
      },

      editItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.items.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
        this.deleteButtonDisabled = true;
        axios.delete(`/api/products/${this.items[this.editedIndex].id}`)
        .then(response => { this.items.splice(this.editedIndex, 1); this.closeDelete(); })
        .catch(error => console.log(error))
        .finally(() => this.deleteButtonDisabled = false)
      },

      close () {
        this.allerrors = []
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        this.saveButtonDisabled = true;
        
        let requestBody = {
          code: this.editedItem.code,
          description: this.editedItem.description,
          vat_category_id: this.editedItem.vatCategory.id,
          measurement_unit_id: this.editedItem.measurementUnit.id,
          suggested_price: this.editedItem.suggested_price,
          income_category_id: this.editedItem.incomeCategory?.id ?? null
        }

        if (this.editedIndex > -1) {
          //Object.assign(this.items[this.editedIndex], this.editedItem)
          axios.patch(`/api/products/${this.editedItem.id}`, requestBody )
          .then(response => { Object.assign(this.items[this.editedIndex], this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
        } else {

          axios.post('/api/products', requestBody )
          .then(response => { console.log(response.data); this.items.push(this.mixmatch(response.data)); this.close(); })
          .catch(error => {
            console.log(error)

            if (error.response.data.errors)
              this.allerrors = error.response.data.errors

          })
          .finally(() => this.saveButtonDisabled = false)
          
        }
      },
    },
  }
</script>

<style>
</style>